var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fcis-spinner"},[_c('wb-spinner',{style:(("width: " + _vm.width + "px; height:" + _vm.height + "px;"))})],1)}
var staticRenderFns = []

export { render, staticRenderFns }